import React from 'react';
const benefits = [{
  num: '01',
  icon: '🔥',
  title: 'TOMO 1 — Classi Pronte Express',
  desc: '30 lezioni functional già pronte da utilizzare.'
}, {
  num: '02',
  icon: '📈',
  title: 'TOMO 2 — Programmazione & Progressioni',
  desc: 'Sistema professionale di pianificazione.'
}, {
  num: '03',
  icon: '👩',
  title: 'TOMO 3 — Functional Women',
  desc: "Allenamenti femminili premium pronti all'uso."
}, {
  num: '04',
  icon: '🧘‍♂️',
  title: 'TOMO 4 — Mobility & Dolore',
  desc: 'Recovery, postura, mobilità e low impact.'
}, {
  num: '05',
  icon: '⚡',
  title: 'TOMO 5 — Small Group & Circuiti',
  desc: 'Classi dinamiche ad alta energia.'
}, {
  num: '06',
  icon: '🏆',
  title: 'TOMO 6 — 12 Settimane Già Pronte',
  desc: '3 mesi completi di programmazione professional.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-1">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" data-id="element-2"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-3">
        <div className="text-center mb-14" data-id="element-4">
          <span className="inline-flex items-center gap-2 bg-primary/15 border border-primary/40 text-primary font-bold uppercase tracking-[0.2em] text-xs sm:text-sm px-4 py-1.5 rounded-sm mb-5" data-id="element-5">
            <span data-id="element-6">📚</span> I 6 Volumi Principali
          </span>
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-4 tracking-tight uppercase" data-id="element-7">
            🎁 Cosa contiene Functional Pronto?
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-8">
            Tutto ciò che ti serve per allenare in modo professionale. In un
            unico sistema digitale completo.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-9">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-7 rounded-sm border border-border-light hover:border-primary/40 transition-all duration-300 relative overflow-hidden group hover:-translate-y-1" data-id="element-10">
              <div className="absolute top-0 left-0 w-full h-1 bg-primary/30 group-hover:bg-primary transition-colors" data-id="element-11"></div>
              <div className="absolute top-3 right-4 font-display text-primary/15 font-bold text-5xl tracking-tighter" data-id="element-12">
                {benefit.num}
              </div>

              <div className="w-14 h-14 rounded-sm bg-primary/10 border border-primary/30 flex items-center justify-center text-3xl mb-5 relative z-10" data-id="element-13">
                {benefit.icon}
              </div>
              <h3 className="font-display text-lg sm:text-xl font-bold text-white relative z-10 uppercase tracking-wide mb-3 leading-tight" data-id="element-14">
                {benefit.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-sm sm:text-base relative z-10" data-id="element-15">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}